module.exports = __webpack_public_path__ + "media/images/payments/applepay-04c2d098b145b4ef153e5e68d4e6a283.svg";